import React from "react";
import styles from "./styles.module.scss";

const AutoDialerContainer = React.memo((props) => (
  <div
    {...props}
    className={styles.autoDialerContainer}
  />
));

AutoDialerContainer.displayName = "AutoDialerContainer";

export default AutoDialerContainer;
